import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-17646 — one block of a booking type's weekly hours. A day can have several; a break
 * such as lunch is the gap between two blocks, and a day with no blocks is unavailable.
 */
@Index('IDX_booking_availability_type', ['fkBookingTypeId'])
@Entity('booking_availability')
export class BookingAvailabilityEntity extends BaseEntity {
	@Column('int', { name: 'fk_booking_type__id', unsigned: true })
	public fkBookingTypeId!: number;

	/** 0 Sunday through 6 Saturday. */
	@Column('tinyint', { name: 'weekday', unsigned: true })
	public weekday!: number;

	/** Minutes after midnight, in the booking type's time zone. */
	@Column('smallint', { name: 'startMinute', unsigned: true })
	public startMinute!: number;

	@Column('smallint', { name: 'endMinute', unsigned: true })
	public endMinute!: number;
}
